import { Button, RadioToggle, SearchBar, Typography } from '@altify/components';
import { useContent } from '@altify/utils';
import { useNavigate } from '@tanstack/react-router';
import clsx from 'clsx';
import Tabs from 'components/Tabs/Tabs';
import { TimeFrameKey, timeFrames } from 'data/time-frames';
import { dollarCurrencyCode, dollarCurrencySymbol } from 'utils/constants';
import { exploreProductsContent } from '../explore.content';
import Dropdown from 'components/Dropdown/Dropdown';
import appUrls from 'utils/app-urls';

const cdnURL = appUrls.getCDNUrl();
const chevronDown = `${cdnURL}assets/components/accordion/chevron-down.svg`;

function ProductsSearch({
  productTabsLength,
  searchQuery,
  setSearchQuery,
  displayCurrency,
  setDisplayCurrency,
  timeframeKey,
  setTimeframeKey,
  baseCurrencyCode,
  baseCurrencySymbol,
  routes,
  activeIndex,
  setSelectionCategoryIsOpen
}: {
  productTabsLength: number;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  baseCurrencyCode?: string;
  baseCurrencySymbol?: string;
  displayCurrency: string;
  setDisplayCurrency: (currency: string) => void;
  timeframeKey: TimeFrameKey;
  setTimeframeKey: (key: TimeFrameKey) => void;
  routes: { value: string; label: string; selectedLabel: string; className: string, textClassName: string; icon: any }[];
  activeIndex: number;
  setSelectionCategoryIsOpen: (value: boolean) => void;
}) {
  const navigate = useNavigate();
  const localizedContent = useContent(exploreProductsContent);

  const timeFrameTabs = Object.values(timeFrames).map(frame => ({
    value: frame.key,
    label: frame.name,
  }));
  const activeTimeFrameIndex = timeFrameTabs.findIndex(
    item => item.value === timeframeKey,
  );

  const activeRoute = routes[activeIndex];

  return (
    <>
    <div className="flex flex-row px-1 gap-4 items-center justify-between">
      <SearchBar
        placeholder="Search Assets"
        fullWidth={true}
        className={clsx(
          'flex-shrink md:flex-grow-0 h-12',
          productTabsLength === 0 &&
            searchQuery &&
            searchQuery != '' &&
            'border-error',
        )}
        value={searchQuery}
        onValueChanged={e => {
          setSearchQuery?.(e ?? '');
        }}
      />
      {!searchQuery &&
        <div className="flex xl:hidden flex items-center basis-[75px] sm:basis-[94px] md:basis-[100px]">
          <Button
            size="large"
            className="px-4 h-12 basis-[75px] md:basis-[100px] sm:basis-[94px]"
            onPress={() => navigate({ to: '/funds/deposit' })}
            text={localizedContent.deposit}
            fullWidth={true}
          />
        </div>
      }

      <div className="hidden xl:flex flex-row gap-2">
        {baseCurrencyCode &&
        baseCurrencySymbol &&
        baseCurrencyCode !== dollarCurrencyCode && (
          <RadioToggle
            options={[
              {
                label: baseCurrencySymbol,
                value: baseCurrencyCode,
              },
              {
                label: dollarCurrencySymbol,
                value: dollarCurrencyCode,
              },
            ]}
            value={displayCurrency}
            onChange={setDisplayCurrency}
            className="w-fit h-12"
          />
        )}
        
        {/* TIMEFRAMES */}
        <Tabs
          underline={false}
          items={timeFrameTabs}
          activeIndex={activeTimeFrameIndex}
          onClickItem={key => setTimeframeKey(key.value)}
        />
        
      </div>

      
    </div>
    {!searchQuery &&
      <div className="flex flex-grow flex-row px-1 gap-4 items-center justify-between">
        <div className="xl:hidden flex items-center justify-start items-start self-start">
          <div className={'flex flex-row justify-start'}>
              <Button 
                size="medium"
                color='secondary'
                className={`w-fit h-12 pl-1 border-0 ${activeRoute?.className ?? ''} hover:${activeRoute?.className ?? ''} active:${activeRoute?.className ?? ''}`}
                onPress={() => setSelectionCategoryIsOpen(true)}>
                  <div className="flex flex-row items-center justify-start gap-2 rounded-full ">
                    <div className={`flex border rounded-full ${activeRoute?.className ?? ''}`}>
                      {activeRoute?.icon && activeRoute.icon()}
                    </div>
                    <Typography weight="medium" size="large" className={clsx('py-0', activeRoute?.textClassName)}>
                      {activeRoute?.selectedLabel ?? ''}
                    </Typography>

                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 6L8 10L4 6" stroke={activeRoute?.selectedLabel === 'Popular' ? `#0C1C2C` : `#FFFFFF`} stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
              </Button>
            </div>
        </div>
        <div className='flex flex-row gap-4'>
          <div className="xl:hidden flex flex-row gap-2 self-end justify-end">   
            {baseCurrencyCode &&
            baseCurrencySymbol &&
            baseCurrencyCode !== dollarCurrencyCode && (
              <RadioToggle
                options={[
                  {
                    label: baseCurrencySymbol,
                    value: baseCurrencyCode,
                  },
                  {
                    label: dollarCurrencySymbol,
                    value: dollarCurrencyCode,
                  },
                ]}
                value={displayCurrency}
                onChange={setDisplayCurrency}
                className="w-fit h-12"
              />
            )}
          </div>

          {/* TIMEFRAMES */}
          {/*
          <div className="xl:hidden flex-row gap-2 self-end"> 
            <Dropdown
              options={Object.values(timeFrames)}
              value={timeframeKey}
              onChange={setTimeframeKey}
            />
          </div>
          */}
        </div>
      </div>
    }
    </>
  );
}

export default ProductsSearch;
